import { getRailsClient } from "../client";

type TrackLessonTimeParams = {
  component: string;
  duration: number;
  parameters: Record<string, any>;
};

export const trackTime = async (trackingParams: TrackLessonTimeParams) => {
  const { component, duration, parameters } = trackingParams;
  const users = {
    component,
    duration,
    parameters,
  };
  try {
    const API = "/api/internal_api/v1/time_tracker/lesson";
    const client = getRailsClient();
    await client.post(API, { users });
  } catch (error) {
    console.error("Error tracking time:", error);
    throw error;
  }
};
